import { FC } from 'react';
import { Link } from 'react-scroll';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Avatar from '@/components/UI/avatar/Avatar';
import Badges from '@/components/UI/badges/Badges';
import userAvatar from '/public/images/product/avatar.svg';
import styles from './HostProfile.module.scss';
type Props = {
  props: ProductItemTypes;
};
const HostProfile: FC<Props> = ({
  props
}) => {
  return <Link to="hostProfile" activeClass="active" smooth spy offset={-130} data-sentry-element="Link" data-sentry-component="HostProfile" data-sentry-source-file="HostProfile.tsx">
      <Box className={styles['host-profile-content']} data-sentry-element="Box" data-sentry-source-file="HostProfile.tsx">
        <Box className={styles['host-profile']} data-sentry-element="Box" data-sentry-source-file="HostProfile.tsx">
          <Avatar alt="host-avatar" src={props?.host?.avatar_path || userAvatar} size={42} data-sentry-element="Avatar" data-sentry-source-file="HostProfile.tsx" />
          <Box className={styles['host-name']} data-sentry-element="Box" data-sentry-source-file="HostProfile.tsx">
            <Typography variant="bodyM" color="secondary_main" data-sentry-element="Typography" data-sentry-source-file="HostProfile.tsx">
              میزبان
            </Typography>
            <Typography variant="bodyM" color="neutral_800" data-sentry-element="Typography" data-sentry-source-file="HostProfile.tsx">
              {props?.host?.name}
            </Typography>
          </Box>
        </Box>
        <Badges type="default" label={`کد آگهی : ${props?.id}`} size="large" data-sentry-element="Badges" data-sentry-source-file="HostProfile.tsx" />
      </Box>
    </Link>;
};
export default HostProfile;